// @flow

const ko = require('knockout');
const $ = require('jquery');
import { matchMedia } from 'window';
import type { Observable } from '../../';

const BTN_GROUP_CLASS = 'btn-group';
const BTN_GROUP_VERTICAL_CLASS = 'btn-group-vertical';

// Parameter: Мedia match 'min-width' word (e.g. '780px') on which button group should be oriented as horizontal.

ko.bindingHandlers.bsBtnGroupAdaptive = {

	init: function (element, valueAccessor: Observable<string>) {

		const jqElement = $(element);

		const matchWidthHandler = (matchResult) => {
			if (matchResult.matches) {
				setHorizontalGroup(jqElement);
			} else {
				setVerticalGroup(jqElement);
			}
		};

		let matchWidthResult = matchMedia(minHorizontalWidthMedia(valueAccessor));
		matchWidthResult.addListener(matchWidthHandler);
		matchWidthHandler(matchWidthResult);

		ko.computed(() => {
			matchWidthResult.removeListener(matchWidthHandler);

			matchWidthResult = matchMedia(minHorizontalWidthMedia(valueAccessor));
			matchWidthResult.addListener(matchWidthHandler);
			matchWidthHandler(matchWidthResult);
		}, null, { disposeWhenNodeIsRemoved: element });

		//eslint-disable-next-line max-len
		ko.utils.domNodeDisposal.addDisposeCallback(element, () => matchWidthResult.removeListener(matchWidthHandler));
	},
};

function minHorizontalWidthMedia (valueAccessor: Observable<string>) {
	return `(min-width: ${minHorizontalWidth(valueAccessor)})`;
}

function minHorizontalWidth (valueAccessor: Observable<string>) {
	return ko.unwrap(valueAccessor()) || 0;
}

function setVerticalGroup (jqElement: *) {
	jqElement.removeClass(BTN_GROUP_CLASS);
	jqElement.addClass(BTN_GROUP_VERTICAL_CLASS);
}

function setHorizontalGroup (jqElement: *) {
	jqElement.removeClass(BTN_GROUP_VERTICAL_CLASS);
	jqElement.addClass(BTN_GROUP_CLASS);
}